import { EyeIcon, UserIcon } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

interface ViewCounterProps {
  postId: string
  initialCount?: number
  uniqueCount?: number
  className?: string
  showDetailed?: boolean
}

/**
 * Component to display the view count for a post
 * Shows an eye icon and the number of views
 * Optionally shows unique views count as well
 */
export const ViewCounter: React.FC<ViewCounterProps> = ({
  postId,
  initialCount = 0,
  uniqueCount,
  className = '',
  showDetailed = false,
}) => {
  // Format the view counts for display
  const formattedTotalCount = new Intl.NumberFormat().format(initialCount)
  const formattedUniqueCount = uniqueCount ? new Intl.NumberFormat().format(uniqueCount) : null

  if (showDetailed && formattedUniqueCount) {
    return (
      <div className={`flex items-center gap-3 text-gray-600 ${className}`}>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger className="flex items-center gap-1">
              <EyeIcon size={18} />
              <span className="text-sm">{formattedTotalCount}</span>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-xs">Total views</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger className="flex items-center gap-1">
              <UserIcon size={18} />
              <span className="text-sm">{formattedUniqueCount}</span>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-xs">Unique visitors</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    )
  }

  // Simple view for minimal display
  return (
    <div className={`flex items-center gap-1 text-gray-600 ${className}`}>
      <EyeIcon size={18} />
      <span className="text-sm">{formattedTotalCount}</span>
    </div>
  )
}
